export default class ForeignSSN {
    static validate(value) {
        if (value === undefined || value === null) {
            return false;
        }

        return value.length >= 6;
    }

    static validateMatch(value, pattern) {
        if (pattern === null || pattern === '' || pattern === undefined) {
            return this.validate(value);
        }
        if (value === undefined || value === null || value.length != pattern.length) {
            return false;
        }

        for (let i = 0; i < value.length; i++) {
            if (pattern[i] === 'x') {
                if (value[i] < '0' || value[i] > '9') {
                    return false;
                }
            } else if (pattern[i] != value[i]) {
                return false;
            }
        }

        return true;
    }
}
